module.exports = __webpack_public_path__ + "static/IMG-20201101-WA0012-f641461a85f55d393ca26a3b63872aab.jpg";